import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Button } from '@/components/ui/button';

interface Props {
 children: ReactNode;
 fallback?: ReactNode;
}

interface State {
 hasError: boolean;
 error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
 public state: State = {
 hasError: false,
 error: null
 };

 public static getDerivedStateFromError(error: Error): State {
 return { hasError: true, error };
 }

 public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
 console.error('Uncaught error:', error, errorInfo);
 }

 public render() {
 if (this.state.hasError) {
 if (this.props.fallback) {
 return this.props.fallback;
 }

 return (
 <div className="min-h-screen flex items-center justify-center">
 <div className="text-center p-8">
 <h1 className="text-2xl font-bold text-foreground mb-4">
 Algo salió mal
 </h1>
 <p className="text-muted-foreground mb-6">
 Ha ocurrido un error inesperado
 </p>
 <Button onClick={() => window.location.reload()}>
 Recargar página
 </Button>
 </div>
 </div>
 );
 }

 return this.props.children;
 }
}